<template>
  <div class="sound-recording">
    <div class="space-x-1">
      <!-- OCR图片上传按钮 -->
      <input
        ref="ocrFileInput"
        class="ocr-file-input"
        type="file"
        accept="image/jpeg,image/jpg,image/png,image/gif,image/bmp,image/webp"
        multiple
        @change="handleOcrFileSelect"
      />
      <el-tooltip class="item" :open-delay=800 effect="dark" content="上传图片进行OCR识别" placement="top">
        <button type="button" class="round ocr-upload-btn" @click="triggerOcrFileSelect">
          <i class="el-icon-picture-outline"></i>
        </button>
      </el-tooltip>
      <el-popover
          ref="chatHistoryPopover"
          placement="bottom"
          width="300px"
          trigger="click"
          v-model="chatHistoryVisible"
          @show="handleShowChatHistory">
        <div class="list-ls">
          <template v-if="chatHistoryData && chatHistoryData.length > 0">
            <div class="item" v-for="(item, index) in chatHistoryData" :key="index" @click="selectChatHistory(item)">
              <span class="name">{{getConversationDescription(item)}}</span>
              <span class="time">{{formatConversationDate(item.createTime)}}</span>
            </div>
          </template>
          <div v-else class="item no-data">
            <span class="name">暂无聊天会话历史</span>
          </div>
        </div>
        <template  #reference>
          <el-tooltip class="item" :open-delay=800  effect="dark" content="查看聊天会话历史" placement="top">
            <button class="round"><i class="el-icon-time"></i></button>
          </el-tooltip>
        </template>
      </el-popover>
      <el-popover
          ref="recordingHistoryPopover"
          placement="bottom"
          width="318px"
          trigger="click"
          @show="handleRecordingHistoryShow">
        <div class="lyls">
          <div class="title">录音历史记录</div>
          <template v-if="recordingHistoryData && recordingHistoryData.length > 0">
            <div
              v-for="(item, index) in recordingHistoryData"
              :key="index"
              class="item"
              @click="selectRecordingHistory(item)">
              <div class="top">
                <span class="tiem">{{formatRecordingDate(item.createTime)}}</span>
                <!-- 暂时隐藏采纳状态 -->
                <!-- <span class="tag green">已采纳</span> -->
              </div>
              <div class="content">
                {{item.aiReturnMsg || '暂无录音内容'}}
              </div>
            </div>
          </template>
          <div v-else class="item no-data">
            <div class="content">暂无录音历史记录</div>
          </div>
        </div>
        <template  #reference>
          <el-tooltip class="item" :open-delay=800  effect="dark" content="查看录音历史记录" placement="top">
            <button class="round"><i class="el-icon-microphone"></i></button>
          </el-tooltip>
        </template>
      </el-popover>
      <el-tooltip class="item" :open-delay=800  effect="dark" content="开始新的对话会话" placement="top">
        <button class="round" @click="startNewConversation"><i class="el-icon-circle-plus-outline"></i></button>
      </el-tooltip>
    </div>
    <div class="space-x-2">
      <el-tooltip class="item" :open-delay=800  effect="dark" content="开始/结束录音，实时采集医患对话" placement="top" v-if="!isRecording" >
        <button @click="startRecording" class="start" :disabled="isStartingRecording || isStoppingRecording"><i class="el-icon-microphone"></i>开始录音</button>
      </el-tooltip>
      <el-tooltip class="item" :open-delay=800  effect="dark" content="开始/结束录音，实时采集医患对话" placement="top" v-else>
       <button @click="stopRecording" class="end" :disabled="isStoppingRecording || isStartingRecording"><i class="el-icon-microphone"></i>结束录音</button>
      </el-tooltip>
    </div>

    <div class="space-x-3" v-if="false">
      <el-popover
          placement="top"
          v-model="visible">
        <div class="popover-content">
          <div class="title"><i class="el-icon-warning"></i>确认全部引用对话记录？</div>
          <div class="txt">此操作将引用全部对话记录给AI修改病历，请确认！</div>
        </div>
        <div style="text-align: right; margin: 0">
          <el-button size="mini" type="text" @click="visible = false">取消</el-button>
          <el-button type="primary" size="mini" @click="visible = false">确定</el-button>
        </div>
        <template #reference>
          <el-tooltip class="item" :open-delay=800  effect="dark" content="全部引用对话记录给AI修改病历" placement="top">
            <button class="round"><svg focusable="false" data-icon="save" width="1em" height="1em" fill="currentColor" aria-hidden="true" viewBox="64 64 896 896"><path d="M893.3 293.3L730.7 130.7c-7.5-7.5-16.7-13-26.7-16V112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V338.5c0-17-6.7-33.2-18.7-45.2zM384 184h256v104H384V184zm456 656H184V184h136v136c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V205.8l136 136V840zM512 442c-79.5 0-144 64.5-144 144s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144zm0 224c-44.2 0-80-35.8-80-80s35.8-80 80-80 80 35.8 80 80-35.8 80-80 80z"></path></svg>全引</button>
          </el-tooltip>
        </template>
      </el-popover>
      <el-popover
          placement="top"
          v-model="templateVisible"
          trigger="click">
        <div class="template-list">
          <div class="title">选择问诊模板</div>
          <div class="template-items">
            <div class="template-item" @click="selectTemplate('儿科问诊模板')">
              <p>儿科问诊模板</p>
              <span>适用于儿童疾病问诊</span>
            </div>
            <div class="template-item" @click="selectTemplate('慢性病随访模板')">
              <p>慢性病随访模板</p>
              <span>适用于慢性病定期随访</span>
            </div>
            <div class="template-item" @click="selectTemplate('常见感冒模板')">
              <p>常见感冒模板</p>
              <span>适用于感冒、发热等常见症状</span>
            </div>
            <div class="template-item" @click="selectTemplate('通用模板')">
              <p>通用模板</p>
              <span>适用于一般问诊场景</span>
            </div>
          </div>
        </div>
        <template #reference>
          <el-tooltip class="item" :open-delay=800  effect="dark" content="选择问诊模板" placement="top">
            <button class="round"><i class="el-icon-document"></i> 模板</button>
          </el-tooltip>
        </template>
      </el-popover>
    </div>

    <!-- 聊天会话历史确认弹窗 -->
    <el-dialog title="重新启用聊天会话" :visible.sync="chatHistoryConfirmVisible" width="80%" custom-class="conversation-resume-dialog" :append-to-body="true">
      <div class="chat-history-confirm-dialog">
        <div class="dialog-content">
          <!-- 左侧：聊天会话历史列表 -->
          <div class="history-list-panel">
            <h4>聊天会话历史</h4>
            <div class="history-scroll-list">
              <div
                v-for="(item, index) in chatHistoryData"
                :key="index"
                class="history-item-in-dialog"
                :class="{ active: selectedChatHistory && selectedChatHistory.id === item.id }"
                @click="switchToChatHistory(item)"
              >
                <div class="date">{{formatConversationDate(item.createTime)}}</div>
                <div class="description">{{getConversationDescription(item)}}</div>
                <div class="session">会话号：{{item.answerNumber || '未知'}}</div>
              </div>
            </div>
          </div>

          <!-- 右侧：会话内容显示 -->
          <div class="history-content-panel">
            <h4>医生-AI对话记录</h4>
            <div class="content-display" v-if="selectedChatHistory">
              <div class="conversation-content" v-if="selectedConversationData && selectedConversationData.length > 0">
                <div class="conversation-header">
                  <div class="session-info">
                    <span class="doctor-info">医生与AI对话：{{selectedChatHistory.answerNumber || '未知会话'}}</span>
                    <span class="time-info">{{formatConversationDate(selectedChatHistory.createTime)}}</span>
                  </div>
                </div>
                <div class="message-list">
                  <div
                    v-for="(message, index) in selectedConversationData"
                    :key="index"
                    class="message-item"
                    :class="{ 'user-message': message.role === 'user', 'assistant-message': message.role === 'assistant' }"
                  >
                    <div class="message-avatar">
                      <span v-if="message.role === 'user'">医</span>
                      <span v-else>AI</span>
                    </div>
                    <div class="message-content">
                      <div class="message-text">{{message.content}}</div>
                      <div class="message-time">{{formatMessageTime(message.created_at)}}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="loading-conversation" v-else-if="loadingConversation">
                <div class="loading-text">正在加载医生-AI对话记录...</div>
              </div>
              <div class="empty-conversation" v-else>
                <div class="empty-text">该会话暂无医生-AI对话记录</div>
              </div>
            </div>
            <div class="content-display" v-else>
              <div class="no-selection">请从左侧选择聊天会话历史查看医生-AI对话记录</div>
            </div>
          </div>
        </div>

        <div class="confirm-action">
          <p><i class="el-icon-warning"></i> 重新启用此聊天会话将切换到对应的患者对话，是否确认？</p>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelUseChatHistory" size="small">取 消</el-button>
        <el-button type="primary" @click="confirmUseChatHistory" size="small">重新启用此聊天会话</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { conversationListLy, conversationDetailLy, selectApi } from "@/services/conversation/index";
import { mapState } from "vuex";
import request from "@/utils/request";

export default {
  props: {
    medmstrId: {
      type: [String, Number],
      default: ''
    },
    chatGroup: {
      type: [String, Number],
      default: ''
    }
  },
  computed: {
    ...mapState(["userInfo"]),

    // 安全获取当前用户ID
    currentUserId() {
      return this.$store.state.myData?.id || this.userInfo?.id || null;
    },

    // 检查用户数据是否已加载
    isUserDataReady() {
      return !!(this.$store.state.myData?.id || this.userInfo?.id);
    }
  },
  data() {
    return {
      mediaRecorder: null,
      audioChunks: [],
      audioBlob: null,
      audioURL: null,
      isRecording: false,
      isStartingRecording: false, // 防止重复点击开始录音按钮
      isStoppingRecording: false, // 防止重复点击结束录音按钮
      lastClickTime: 0, // 上次点击时间，用于防抖
      visible: false,
      templateVisible: false,
      chatHistoryVisible: false, // 控制聊天会话历史下拉菜单
      chatHistoryConfirmVisible: false, // 控制聊天会话历史确认弹窗
      chatHistoryData: [], // 聊天会话历史数据
      selectedChatHistory: null, // 选中的聊天会话历史
      selectedConversationData: [], // 选中会话的对话内容
      loadingConversation: false, // 正在加载会话内容
      recordingHistoryData: [], // 录音历史数据
      // 音量检测相关
      audioContext: null,
      analyser: null,
      dataArray: null,
      source: null,
      volumeLevel: 0,
      recordingTimer: null,
      recordingDuration: 0
    };
  },
  watch: {
    chatHistoryConfirmVisible(val) {
      if (val) {
        // 弹窗打开时，优先展示已选择项；否则默认展示第一条
        const item = this.selectedChatHistory || (this.chatHistoryData && this.chatHistoryData[0]);
        if (item) {
          // 确保在DOM更新后触发加载
          this.$nextTick(() => {
            this.switchToChatHistory(item);
          });
        }
      }
    }
  },
  methods: {
    startRecording() {
      // 防重复提交：如果正在启动录音或正在停止录音，直接返回（最优先检查）
      if (this.isStartingRecording || this.isRecording || this.isStoppingRecording) {
        console.warn('录音正在启动中、已开始或正在停止，请勿重复点击');
        return;
      }

      // 防抖：500ms内只能点击一次
      const now = Date.now();
      if (now - this.lastClickTime < 500) {
        console.warn('操作过于频繁，请稍后再试');
        return;
      }
      this.lastClickTime = now;

      // 检查是否选择了患者
      if (!this.medmstrId) {
        this.$message && this.$message.warning("请先选择患者");
        return;
      }

      // 检查浏览器支持
      if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
        this.$message.error('当前浏览器不支持录音功能，请使用 HTTPS 协议访问');
        return;
      }

      // 检查协议安全性
      if (location.protocol !== 'https:' && location.hostname !== 'localhost' && location.hostname !== '127.0.0.1') {
        this.$message.error('录音功能需要 HTTPS 协议支持，请使用 HTTPS 访问');
        return;
      }

      // 设置启动状态，防止重复点击（立即设置，确保UI立即更新）
      this.isStartingRecording = true;

      this.audioURL = null;
      this.recordingDuration = 0;
      navigator.mediaDevices
        .getUserMedia({ audio: true, video: false })
        .then(stream => {
          // 配置 MediaRecorder 选项，设置较低的比特率以减小文件大小
          // 32kbps 适合语音录音，文件大小约为 240KB/分钟（10分钟约2.4MB）
          // 如果质量不够，可以提高到 64kbps（约 480KB/分钟）
          const options = {
            mimeType: 'audio/webm;codecs=opus',
            audioBitsPerSecond: 32000 // 32kbps，适合语音录音
          };

          // 检查浏览器是否支持指定的 mimeType
          if (MediaRecorder.isTypeSupported(options.mimeType)) {
            this.mediaRecorder = new MediaRecorder(stream, options);
          } else {
            // 如果不支持，使用默认配置
            this.mediaRecorder = new MediaRecorder(stream);
            console.warn('浏览器不支持指定的音频编码格式，使用默认配置');
          }

          this.mediaRecorder.ondataavailable = e => {
            this.audioChunks.push(e.data);
          };
          this.mediaRecorder.onstop = e => {
            //语音类型设置
            if (this.mediaRecorder.mimeType.includes("audio/webm")) {
              this.audioBlob = new Blob(this.audioChunks, {
                type: "audio/webm"
              }); //mpeg(MP3格式)/wav/webm 谷歌只支持webm
            } else {
              this.audioBlob = new Blob(this.audioChunks, {
                type: "audio/mpeg"
              }); //mpeg(MP3格式)/wav/webm 谷歌只支持webm
            }

            // 检查文件大小（10MB = 10 * 1024 * 1024 字节）
            const fileSizeMB = this.audioBlob.size / (1024 * 1024);
            console.log(`录音文件大小: ${fileSizeMB.toFixed(2)} MB`);

            // 如果文件超过 80MB，提示用户（nginx 限制为 100MB）
            if (this.audioBlob.size > 80 * 1024 * 1024) {
              this.$message.warning(`录音文件较大（${fileSizeMB.toFixed(2)}MB），上传可能需要较长时间，请确保网络连接稳定`);
            }

            this.audioURL = URL.createObjectURL(this.audioBlob);
            this.audioChunks = []; // 清除chunks，以便下次使用
            this.isRecording = false; // 停止录音后更新状态

            // 停止音量检测
            this.stopVolumeDetection();

            // 立即发送录音状态变化事件，确保UI更新
            this.$emit("recordingStateChange", {
              isRecording: false,
              duration: this.recordingDuration,
              volumeLevel: 0
            });

            // 录音结束后自动识别
            setTimeout(() => {
              if (this.audioBlob) {
                this.handleShibie();
              }
            }, 100);
          };

          this.mediaRecorder.start();
          this.isRecording = true; // 开始录音后更新状态
          this.isStartingRecording = false; // 录音已成功启动，重置启动状态

          // 开始音量检测
          this.startVolumeDetection(stream);

          // 开始计时
          this.startTimer();

          this.$emit("recordingStateChange", { isRecording: true, duration: 0 });
          console.log("开始录音", this.audioURL);
        })
        .catch(error => {
          console.error("Error accessing the media devices.", error);
          this.isStartingRecording = false; // 启动失败，重置启动状态
          this.$message.error('启动录音失败，请重试');
        });
    },

    stopRecording() {
      // 防重复提交：如果正在停止录音或正在启动录音，直接返回（最优先检查）
      if (this.isStoppingRecording || this.isStartingRecording || !this.isRecording) {
        console.warn('录音正在停止中、正在启动或未开始，请勿重复点击');
        return;
      }

      // 防抖：500ms内只能点击一次
      const now = Date.now();
      if (now - this.lastClickTime < 500) {
        console.warn('操作过于频繁，请稍后再试');
        return;
      }
      this.lastClickTime = now;

      // 设置停止状态，防止重复点击（立即设置，确保UI立即更新）
      this.isStoppingRecording = true;

      if (this.mediaRecorder && this.isRecording) {
        console.log("Stopping recording...");

        // 立即停止计时和音量检测，确保UI立即更新
        this.stopTimer();
        this.stopVolumeDetection();

        // 立即更新状态并发送事件，确保录音进度条立即隐藏
        this.isRecording = false;
        this.volumeLevel = 0;
        this.$emit("recordingStateChange", {
          isRecording: false,
          duration: this.recordingDuration,
          volumeLevel: 0
        });

        // 停止录音器
        this.mediaRecorder.stop();

        // 重置停止状态
        this.isStoppingRecording = false;

        console.log("录音已停止");
      } else {
        // 如果没有录音器或未在录音，重置状态
        this.isRecording = false;
        this.isStoppingRecording = false;
        this.stopTimer();
        this.stopVolumeDetection();
        this.volumeLevel = 0;
        this.$emit("recordingStateChange", {
          isRecording: false,
          duration: 0,
          volumeLevel: 0
        });
      }

      if (this.audioURL) {
        console.log("audioURL",this.audioURL);
        URL.revokeObjectURL(this.audioURL);
      }

      // 确保录音状态完全重置
      this.recordingDuration = 0;
    },

    // 开始音量检测
    startVolumeDetection(stream) {
      try {
        this.audioContext = new (window.AudioContext || window.webkitAudioContext)();
        this.analyser = this.audioContext.createAnalyser();
        this.source = this.audioContext.createMediaStreamSource(stream);

        this.analyser.fftSize = 512;  // 从256改为512，提高精度
        this.analyser.smoothingTimeConstant = 0.3;  // 降低平滑度，响应更快
        const bufferLength = this.analyser.frequencyBinCount;
        this.dataArray = new Uint8Array(bufferLength);

        this.source.connect(this.analyser);

        this.detectVolume();
      } catch (error) {
        console.error('启动音量检测失败:', error);
      }
    },

    // 检测音量 - 优化刷新速度
    detectVolume() {
      if (!this.isRecording || !this.analyser) return;

      this.analyser.getByteFrequencyData(this.dataArray);
      let sum = 0;
      for (let i = 0; i < this.dataArray.length; i++) {
        sum += this.dataArray[i];
      }
      const average = sum / this.dataArray.length;
      this.volumeLevel = Math.round((average / 255) * 100);

      // 立即再次请求，实现最快刷新速度
      requestAnimationFrame(() => this.detectVolume());
    },

    // 停止音量检测
    stopVolumeDetection() {
      if (this.audioContext) {
        this.audioContext.close();
        this.audioContext = null;
      }
      if (this.source) {
        this.source.disconnect();
        this.source = null;
      }
      this.analyser = null;
      this.dataArray = null;
      this.volumeLevel = 0;
    },

    // 开始计时
    startTimer() {
      this.recordingTimer = setInterval(() => {
        this.recordingDuration++;
        this.$emit("recordingStateChange", {
          isRecording: true,
          duration: this.recordingDuration,
          volumeLevel: this.volumeLevel
        });
      }, 1000);
    },

    // 停止计时
    stopTimer() {
      if (this.recordingTimer) {
        clearInterval(this.recordingTimer);
        this.recordingTimer = null;
      }
    },

    // 格式化时间显示
    formatTime(seconds) {
      const mins = Math.floor(seconds / 60).toString().padStart(2, '0');
      const secs = (seconds % 60).toString().padStart(2, '0');
      return `${mins}:${secs}`;
    },

    uploadRecording() {
      if (this.audioBlob) {
        // 在这里执行上传操作，例如发送到服务器
        this.$emit("uploadRecording", this.audioBlob);
      } else {
        console.log("没有录音可上传");
      }
    },

    /* 识别 */
    async handleShibie() {
      this.$emit("handleShibie", this.audioBlob, this.getChatGroupValue());
    },

    /* 选择模板 */
    selectTemplate(templateName) {
      this.templateVisible = false;
      this.$emit("selectTemplate", templateName);
      console.log(`已选择：${templateName}`);
    },

    /* 加载聊天会话历史数据（改为 /ly/conversation/list） */
    async loadChatHistoryData() {
      if (!this.medmstrId) {
        this.chatHistoryData = [];
        return;
      }
      if (!this.isUserDataReady || !this.currentUserId) {
        console.warn('用户数据未加载，无法获取聊天会话历史');
        this.chatHistoryData = [];
        return;
      }

      try {
        // 新接口参数：{ medmstrId, professionalId, pageNum, pageSize, chatGroup? }
        const params = {
          medmstrId: this.medmstrId || '',
          professionalId: this.userInfo?.id || '',
          pageNum: 1,
          pageSize: 10,
          visitNum: localStorage.getItem('visitNum') || ''
        };
        // 只有当 chatGroup 有值时才添加该参数（门诊病历不需要，住院病历需要）
        const chatGroupValue = this.getChatGroupValue();
        if (chatGroupValue !== undefined && chatGroupValue !== null && chatGroupValue !== '') {
          params.chatGroup = chatGroupValue;
        }
        const res = await conversationListLy(params);
        // 实际返回：{ success, code, result: [ ... ] }
        const list = Array.isArray(res?.result) ? res.result : [];
        this.chatHistoryData = list.map(item => ({
          id: item.id,
          answerNumber: item.id, // 兼容旧UI字段
          phone: item.patientPhone,
          patientName: item.patientName,
          createTime: item.sessionTime,
          messageCount: item.messageCount,
          summary: item.summary,
          medmstrId: item.medmstrId,
          chatGroup: this.getChatGroupValue()
        }));
      } catch (error) {
        console.error('加载聊天会话历史失败:', error);
        this.chatHistoryData = [];
      }
    },

    /* 选择聊天会话历史 - 弹出确认窗口 */
    selectChatHistory(item) {
      this.selectedChatHistory = item;
      this.chatHistoryVisible = false; // 关闭下拉菜单
      this.chatHistoryConfirmVisible = true; // 显示确认弹窗
    },

    /* 确认重新启用聊天会话 */
    confirmUseChatHistory() {
      if (!this.medmstrId) {
        this.$message && this.$message.warning('请先选择患者');
        this.chatHistoryConfirmVisible = false;
        return;
      }
      if (this.selectedChatHistory) {
        // 通知父组件切换到选中的聊天会话
        this.$emit('switchToConversation', {
          ...this.selectedChatHistory,
          chatGroup: this.getChatGroupValue()
        });
        this.chatHistoryConfirmVisible = false;
        this.selectedChatHistory = null;
      }
    },

    /* 取消启用聊天会话 */
    cancelUseChatHistory() {
      this.chatHistoryConfirmVisible = false;
      this.selectedChatHistory = null;
    },

    /* 在确认窗口中切换到其他聊天会话历史 */
    switchToChatHistory(item) {
      this.selectedChatHistory = item;
      // 延迟加载对话内容，确保数据状态稳定
      this.$nextTick(() => {
        this.loadConversationData(item.id || item.answerNumber);
      });
    },

    /* 格式化会话日期 */
    formatConversationDate(dateString) {
      if (!dateString) return '未知日期';
      const safeStr = typeof dateString === 'string' ? dateString.replace(' ', 'T') : dateString;
      const date = new Date(safeStr);
      if (isNaN(date.getTime())) return '未知日期';
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      return `${month}-${day} ${hours}:${minutes}`;
    },

    /* 获取会话描述信息 */
    getConversationDescription(item) {
      if (!item) return '未知会话';
      if (item.patientName) {
        return `患者: ${item.patientName}${item.phone ? '（' + item.phone + '）' : ''}`;
      }
      if (item.phone) {
        return `患者: ${item.phone}`;
      }
      return item.answerNumber || item.id || '未知会话';
    },

    /* 获取就诊状态文字 */
    getMedicalStatus(status) {
      const statusMap = {
        0: '待接诊',
        1: '进行中',
        2: '已完成',
        3: '已取消'
      };
      return statusMap[status] || '未知状态';
    },

    /* 加载会话对话内容（改为 /ly/conversation/detail） */
    async loadConversationData(conversationId) {
      if (!conversationId) {
        this.selectedConversationData = [];
        return;
      }

      // 检查用户数据是否已加载
      if (!this.isUserDataReady || !this.currentUserId) {
        console.warn('用户数据未加载，无法获取医生-AI对话记录');
        this.selectedConversationData = [];
        return;
      }

      this.loadingConversation = true;
      this.selectedConversationData = [];

      try {
        // 构建请求参数：住院病历需要传递 chatGroup，门诊病历不需要
        const params = { conversationId };
        const chatGroupValue = this.getChatGroupValue();
        if (chatGroupValue !== undefined && chatGroupValue !== null && chatGroupValue !== '') {
          params.chatGroup = chatGroupValue;
        }
        const res = await conversationDetailLy(params);
        const messages = res?.result?.conversationData || [];
        // 映射为UI需要的结构 { role: 'user'|'assistant', content, created_at }
        this.selectedConversationData = messages.map(m => ({
          role: m.senderType === 'doctor' ? 'user' : 'assistant',
          content: m.content,
          created_at: m.createTime
        }));
        // 按时间排序显示
        this.selectedConversationData.sort((a, b) => new Date(a.created_at) - new Date(b.created_at));
      } catch (error) {
        console.error('获取医生-AI对话记录失败:', error);
        this.selectedConversationData = [];
        console.error('获取医生-AI对话记录失败');
      } finally {
        this.loadingConversation = false;
      }
    },

    /* 格式化消息时间 */
    formatMessageTime(timeStr) {
      if (!timeStr) return '';

      try {
        const date = new Date(timeStr);
        if (isNaN(date.getTime())) return '';

        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');

        return `${hours}:${minutes}`;
      } catch (error) {
        console.error('时间格式化错误:', error);
        return '';
      }
    },

    /* 开始新的对话会话 */
    startNewConversation() {
      if (!this.medmstrId) {
        this.$message && this.$message.warning('请先选择患者');
        return;
      }
      // 通知父组件开始新会话
      this.$emit('startNewConversation', this.getChatGroupValue());
    },


    /* 选择录音历史记录 */
    selectRecordingHistory(item) {
      // 通知父组件选择录音历史
      this.$emit('selectRecordingHistory', item);
    },

    /* 格式化录音日期 */
    formatRecordingDate(dateString) {
      if (!dateString) return '未知日期';
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return '未知日期';
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      return `${month}-${day} ${hours}:${minutes}`;
    },

    handleShowChatHistory() {
      if (!this.medmstrId) {
        this.chatHistoryVisible = false;
        this.$message && this.$message.warning('请先选择患者');
        return;
      }
      this.loadChatHistoryData();
    },

    handleRecordingHistoryShow() {
      if (!this.medmstrId) {
        this.$refs.recordingHistoryPopover && this.$refs.recordingHistoryPopover.doClose && this.$refs.recordingHistoryPopover.doClose();
        this.$message && this.$message.warning('请先选择患者');
        return;
      }
      this.$emit('loadRecordingHistory', this.getChatGroupValue());
    },

    getChatGroupValue() {
      // 如果 chatGroup 为 0，返回 0（特殊值，表示不需要分组）
      if (this.chatGroup === 0) {
        return 0;
      }
      // 如果 chatGroup 有值，返回该值；否则返回 undefined（门诊病历不需要分组）
      return this.chatGroup !== undefined && this.chatGroup !== null && this.chatGroup !== '' ? this.chatGroup : undefined;
    },

    /* 触发 OCR 文件选择 */
    triggerOcrFileSelect() {
      if (!this.medmstrId) {
        this.$message && this.$message.warning('请先选择患者');
        return;
      }
      this.$refs.ocrFileInput && this.$refs.ocrFileInput.click();
    },

    /* OCR文件选择事件处理 */
    handleOcrFileSelect(event) {
      const files = event.target.files;
      if (!files || files.length === 0) {
        return;
      }

      // 检查文件类型
      const imageTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/bmp', 'image/webp'];
      const invalidFiles = Array.from(files).filter(file => !imageTypes.includes(file.type));
      if (invalidFiles.length > 0) {
        this.$message && this.$message.warning('请选择图片文件（jpg、png、gif、bmp、webp）');
        event.target.value = '';
        return;
      }

      // 通知父组件处理OCR文件上传
      this.$emit('ocrFileSelect', files);

      // 清空文件选择，以便下次可以选择相同文件
      event.target.value = '';
    }
  },

  beforeDestroy() {
    // 清理资源
    this.stopVolumeDetection();
    this.stopTimer();
  }
};
</script>

<style scoped>
.sound-recording {
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.18);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  box-sizing: border-box;
  padding: 0.75rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 24px 24px 0 0;
  position:relative;
  white-space: nowrap;
  overflow-x: auto;
  .space-x-1{
    display: inline-flex;
    align-items: center;

    .ocr-file-input {
      display: none;
    }

    .el-tooltip {
      display: inline-flex;
    }

    .round,
    .ocr-upload-btn {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      box-sizing: border-box;
      padding: 0;
      flex-shrink: 0;
      background-color: transparent !important;
      color: #4169e1 !important;
      border: 1px solid #d1d1d6 !important;
      border-radius: 9999px !important;
      box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.2) !important;
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
      margin-right: 0.5rem;
      width: 40px;
      height: 40px;
      min-width: 40px;
      min-height: 40px;
      font-size: 18px;
      line-height: 1;
      cursor: pointer;

      i {
        font-size: 18px;
        line-height: 1;
      }

      &:hover {
        cursor: pointer;
        box-shadow: 0 6px 16px rgba(0, 0, 0, 0.18) !important;
        transform: translateY(-3px) scale(1.1) !important;
      }
    }
    .el-popover{
      padding: 0!important;
    }
  }
  .space-x-2{
      button{
        background-color: white !important;
        color: #4169e1 !important;
        border: 1px solid #d1d1d6 !important;
        border-radius: 9999px !important;
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
        transition: all 0.3s !important;
        cursor: pointer;
        margin-right: 0.5rem;
        font-weight: 500;
        font-size: 0.75rem;
        line-height: 1rem;
        padding-top: 0.25rem;
        padding-bottom: 0.25rem;
        padding-left: 0.75rem;
        padding-right: 0.75rem;
        box-sizing: border-box;
        line-height: 26px;
        font-size: 14px;
        /*&:nth-child(2){*/
        /*    margin-right: 0;*/
        /* }*/
      }
      .end{
        background: #d32f2f !important;
        color: #fff!important;
        line-height: 34px!important;
        padding: 0.25rem 22px;
        min-width: 144px !important;
        box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.2) !important;
        transition: all 0.3s ease !important;
      }
      .end:hover:not(:disabled) {
        opacity: 0.9 !important;
        transform: translateY(-2px) !important;
        box-shadow: 0 6px 12px rgba(211, 47, 47, 0.4) !important;
      }
      .end:disabled {
        opacity: 0.6 !important;
        cursor: not-allowed !important;
        transform: none !important;
      }
      .start{
        background-color: #ff9500 !important;
        color: #fff !important;
        border-color: #ff9500 !important;
        box-shadow: 0 4px 12px rgba(255, 149, 0, 0.3) !important;
        line-height: 34px!important;
        padding: 0.25rem 22px;
        min-width: 144px !important;
        transition: all 0.3s ease !important;
      }
      .start:hover:not(:disabled) {
        opacity: 0.9 !important;
        transform: translateY(-2px) scale(1.08) !important;
        box-shadow: 0 6px 16px rgba(255, 149, 0, 0.4) !important;
      }
      .start:disabled {
        opacity: 0.6 !important;
        cursor: not-allowed !important;
        transform: none !important;
      }
  }
  .space-x-3{
    display: flex;
    button{
      background-color: white !important;
      color: #4169e1 !important;
      border: 1px solid #d1d1d6 !important;
      border-radius: 9999px !important;
      box-shadow:0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.2) !important;
      transition: all 0.3s !important;
      cursor: pointer;
      margin-right: 0.5rem;
      font-weight: 500;
      font-size: 0.75rem;
      line-height: 1rem;
      padding-top: 0.25rem;
      padding-bottom: 0.25rem;
      padding-left: 0.75rem;
      padding-right: 0.75rem;
      box-sizing: border-box;
      line-height: 26px;
      &:nth-child(1){
         display: flex;
         justify-content: center;
         align-items: center;
      }
       svg{
         margin-right: 3px;
       }
      &:hover {
         cursor: pointer;
         box-shadow: 0 6px 16px rgba(0, 0, 0, 0.18) !important;
         transform: translateY(-3px) scale(1.1) !important;
       }
      &:nth-child(3){
         margin-right: 0;
       }
    }
  }
}
button:hover {
  cursor: pointer;
}

/* 聊天会话历史确认弹窗样式 */
.chat-history-confirm-dialog {
  .dialog-content {
    display: flex;
    gap: 1.5rem;
    height: 500px;
    margin-bottom: 1.5rem;
  }

  .history-list-panel {
    flex: 0 0 300px;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    overflow: hidden;

    h4 {
      margin: 0;
      padding: 1rem;
      background: #f8f9fa;
      border-bottom: 1px solid #e5e7eb;
      color: #1a1a1a;
      font-size: 1rem;
      font-weight: 600;
    }

    .history-scroll-list {
      height: calc(100% - 60px);
      overflow-y: auto;

      .history-item-in-dialog {
        padding: 0.75rem;
        border-bottom: 1px solid #f3f4f6;
        cursor: pointer;
        transition: background-color 0.2s;

        &:hover {
          background-color: #f9fafb;
        }

        &.active {
          background-color: #eff6ff;
          border-left: 3px solid #4169e1;
        }

        &:last-child {
          border-bottom: none;
        }

        .date {
          font-size: 0.85rem;
          color: #4169e1;
          font-weight: 500;
          margin-bottom: 0.25rem;
        }

        .description {
          font-size: 0.9rem;
          color: #1a1a1a;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          margin-bottom: 0.25rem;
        }

        .session {
          font-size: 0.8rem;
          color: #6b7280;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }

  .history-content-panel {
    flex: 1;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    overflow: hidden;

    h4 {
      margin: 0;
      padding: 1rem;
      background: #f8f9fa;
      border-bottom: 1px solid #e5e7eb;
      color: #1a1a1a;
      font-size: 1rem;
      font-weight: 600;
    }

    .content-display {
      height: calc(100% - 60px);
      overflow-y: auto;

      .no-selection {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        color: #9ca3af;
        font-size: 0.9rem;
      }

      .loading-conversation {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        color: #6b7280;
        font-size: 0.9rem;
      }

      .empty-conversation {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        color: #9ca3af;
        font-size: 0.9rem;
      }

      .conversation-content {
        padding: 1rem;

        .conversation-header {
          .session-info {
            padding: 0.75rem;
            background: #f9fafb;
            border-radius: 6px;
            margin-bottom: 1rem;
            border: 1px solid #e5e7eb;

            .doctor-info {
              color: #1f2937;
              font-weight: 500;
              margin-right: 1rem;
            }

            .time-info {
              color: #6b7280;
              font-size: 0.85rem;
            }
          }
        }

        .message-list {
          .message-item {
            display: flex;
            margin-bottom: 1rem;

            &.user-message {
              .message-avatar {
                background: #fef3c7;
                color: #d97706;
              }

              .message-content {
                .message-text {
                  background: #fef3c7;
                  border: 1px solid #fcd34d;
                }
              }
            }

            &.assistant-message {
              .message-avatar {
                background: #f0fdf4;
                color: #16a34a;
              }

              .message-content {
                .message-text {
                  background: #f0fdf4;
                  border: 1px solid #dcfce7;
                }
              }
            }

            .message-avatar {
              width: 32px;
              height: 32px;
              border-radius: 50%;
              display: flex;
              align-items: center;
              justify-content: center;
              font-size: 0.75rem;
              font-weight: 600;
              margin-right: 0.75rem;
              flex-shrink: 0;
            }

            .message-content {
              flex: 1;

              .message-text {
                padding: 0.75rem;
                border-radius: 8px;
                line-height: 1.5;
                font-size: 0.9rem;
                color: #1f2937;
                word-wrap: break-word;
                margin-bottom: 0.25rem;
              }

              .message-time {
                font-size: 0.75rem;
                color: #9ca3af;
                padding-left: 0.5rem;
              }
            }
          }
        }
      }
    }
  }

  .confirm-action {
    padding: 1rem;
    background: #fef3cd;
    border: 1px solid #fbbf24;
    border-radius: 6px;

    p {
      margin: 0;
      font-size: 0.9rem;
      color: #92400e;

      i {
        margin-right: 0.5rem;
        color: #f59e0b;
      }
    }
  }
}

.list-ls{
.item{
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  padding-left: 1rem;
  padding-right: 1rem;
  display: flex;
  justify-content: space-between;
  cursor: pointer;
    .name{
      font-weight: 500;
      line-height: 1rem;
      font-size: 14px;
    }
    .time{
      color: #aeaeb2;
      font-size: 12px;
      padding-top: 0.125rem;
      padding-bottom: 0.125rem;
      padding-left: 0.5rem;
      padding-right: 0.5rem;
      background: #f2f2f7;
      border-radius: 9999px;
    }
    &:hover{
      background: #f2f2f7;
     }
  }
}
.lyls{
  width: 318px;
  .title{
    font-weight: 500;
    line-height: 1rem;
    font-size: 16px;
    padding-bottom: 0.75rem;
    color: #2563eb;
    border-bottom: 1px solid #f2f3f5;
  }
  .item{
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
    padding-left: 1rem;
    padding-right: 1rem;
    cursor: pointer;
    &:hover{
      background: #f2f2f7;
     }
     .top{
       display: flex;
       margin-bottom: 0.25rem;
       justify-content: space-between;
       .tiem{
         font-size: 0.875rem;
         line-height: 1.25rem;
         font-weight: 500;
         color: #1c1c1e;
       }
       .tag{
         box-sizing: border-box;
         margin: 0;
         padding: 0;
         font-size: 12px;
         line-height: 20px;
         list-style: none;
         font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji';
         display: inline-block;
         height: auto;
         margin-inline-end: 8px;
         padding-inline: 7px;
         white-space: nowrap;
         background: rgba(0, 0, 0, 0.02);
         border: 1px solid #d9d9d9;
         border-radius: 4px;
         opacity: 1;
         transition: all 0.2s;
         text-align: start;
         &.green{
            color: #389e0d;
            background: #f6ffed;
            border-color: #b7eb8f;
          }
       }
     }
    .content{
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2; /* 限制在一个块元素显示的文本的行数 */
      overflow: hidden;
      color: #aeaeb2;
      font-size: 12px;
    }
  }
  .template-list {
    .title {
      font-weight: 600;
      color: #1c1c1e;
      padding: 0.75rem;
      border-bottom: 1px solid #f0f0f0;
      font-size: 16px;
    }

    .template-items {
      max-height: 300px;
      overflow-y: auto;

      .template-item {
        padding: 0.75rem 1rem;
        cursor: pointer;
        transition: background-color 0.2s;
        border-bottom: 1px solid #f8f9fa;

        &:hover {
          background-color: #f8f9fa;
        }

        &:last-child {
          border-bottom: none;
        }

        p {
          font-weight: 500;
          font-size: 14px;
          color: #1c1c1e;
          margin-bottom: 0.25rem;
          margin: 0 0 0.25rem 0;
        }

        span {
          color: #aeaeb2;
          font-size: 12px;
          line-height: 1.4;
        }
      }
    }
  }
}
.popover-content{
.title{
  font-weight: 600;
  display: flex;
  align-items: center;
  color: #1c1c1e;
i{
  color: #faad14;
  margin-right: 0.25rem;
}
}
.txt{
  padding: 0.5rem;
}
}
.audio{
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  padding-left: 1rem;
  padding-right: 1rem;
  background-color: #eff6ff;
  width:100%;
  .top{
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-radius: 0.375rem;
    .left{
      display: flex;
      align-items: center;
      .red{
        animation: recording-pulse 1.5s ease-in-out infinite;
background-color: #ef4444;
        width: 0.75rem;
        height: 0.75rem;
        margin-right: 0.5rem;
        border-radius: 50%;
      }
    }
    .right{
      font-size: 0.75rem;
      line-height: 1rem;
      padding-top: 0.25rem;
      padding-bottom: 0.25rem;
      padding-left: 0.5rem;
      padding-right: 0.5rem;
      background-color: #f2f2f7;
      border-radius: 0.375rem;
    }
  }
  .bottom{
    position: relative;
    width: 100%;
    height: 64px;
    box-shadow:0 2px 4px 0 rgb(0 0 0 / 0.05) inset;
    background: #f2f2f7;
    border-radius: 16px;
    border: 1px solid #e5e5ea;
    .ylNumber{
      position: absolute;
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      z-index:4;
      .number{
        background: rgba(255,255,255,.9);
        padding-top: 0.25rem;
        padding-bottom: 0.25rem;
        padding-left: 0.75rem;
        padding-right: 0.75rem;
        border: 1px solid #e5e5ea;
        border-radius: 9999px;
        font-weight: 600;
        color: #636366;
      }
    }
    .strip{
      opacity: 0.8;
      box-shadow: rgba(59, 130, 246, 0.5) 0px 0px 7.04946px;
      background-image: linear-gradient(to right, #6aa0f3, #a864ee, #76e3a2, #669cf6, #6aa0f3);
      background-size: 200% 100%;
      animation: level-gradient 3s ease infinite;
      position: absolute;
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
      width: 50%;
      z-index: 3;
      border-radius: 16px 0 0 16px;
    }
  }
  .lineBox{
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    z-index: 2;
    .line{
      opacity: 0.5;
      background-color: #d1d1d6;
      width: 1px;
      height: 0.75rem;
    }
  }
  .hdbh{
    animation: pulse 0.590107s cubic-bezier(0.4, 0, 0.6, 1) infinite;
    border-radius: 16px;
    background-color: rgb(96,165 ,250,1);
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    z-index: 1;
  }
}
@keyframes recording-pulse {
  0%, 100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.6;
    transform: scale(1.1);
  }
}
@keyframes  pulse{
  50% {
    opacity: .5;
  }
}
@keyframes  level-gradient{
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}
@keyframes level-gradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}
</style>
